import React from "react";

import {CheckboxQuestionMethods} from "../CheckboxQuestion";
import CheckboxCard from "./components/CheckboxCard";
import {DisabledReasonTooltip} from "../../../../../../../components/Tooltip";

const CheckboxCardQuestion = props => {
  const {
    question,
    onAnswerChange,
    disabled,
    custom_classes
  } = props;

  const label = question.question_text || '';
  const helpText = question.info;
  const required = CheckboxQuestionMethods.required(question) || question.required_check;
  const isChecked = question.answer || false;

  const switchValue = () => {
    question.error = null;  // clean error
    onAnswerChange(question.uid, !isChecked);
  };

  return (
    <DisabledReasonTooltip title={(disabled && question.disabledReason) || question.infoText} position={'bottom'} width={600} interactive={!!question.infoText}>
      <div>
        <CheckboxCard
          value={isChecked}
          onChange={switchValue}
          disabled={disabled}
          label={label}
          name={question.uid}
          required={required}
          custom_classes={custom_classes || question.custom_classes}
          error={question.error}
          helpText={helpText}
        />
      </div>
    </DisabledReasonTooltip>
  )
};

export default CheckboxCardQuestion;